var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"credential_button",class:_vm.blank ? 'new_credential' : '',on:{"click":function($event){return _vm.$emit('open', _vm.name)}}},[_c('v-card-text',[(!_vm.blank)?_c('CrendentialIcon'):_c('IconAddNewTemplate'),_c('span',[_vm._v(_vm._s(_vm.name))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }